import { render, staticRenderFns } from "./icon-printer.vue?vue&type=template&id=64246df6&lang=pug&"
var script = {}
import style0 from "./icon-printer.vue?vue&type=style&index=0&id=64246df6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports